var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "13px",
    viewBox: "0 0 15 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Caution@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Toast",
    transform: "translate(-696.000000, -899.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toast---Orange",
    transform: "translate(685.000000, 881.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4930869,31 C25.9583009,31 26.1278159,30.4067914 25.8985421,30.0059682 L19.2426964,18.3670159 C18.962949,17.8776614 18.0370446,17.8776614 17.7572972,18.3670159 L11.1014516,30.0059682 C10.8721777,30.4067914 11.0416928,31 11.5071448,31 L25.4930869,31 Z M19.2634096,21.8871094 L19.2634096,26.6955285 L17.7368221,26.6955285 L17.7368221,21.8871094 L19.2634096,21.8871094 Z M19.2634096,27.6701029 L19.2634096,29.1483817 L17.7368221,29.1483817 L17.7368221,27.6701029 L19.2634096,27.6701029 Z",
    id: "Caution"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.72374dd0981aa7f29eb1a04f0760f60b.svg";
export { ForwardRef as ReactComponent };